import { render, staticRenderFns } from "./MallItem.vue?vue&type=template&id=5c447214&scoped=true&"
import script from "./MallItem.vue?vue&type=script&lang=ts&"
export * from "./MallItem.vue?vue&type=script&lang=ts&"
import style0 from "./MallItem.vue?vue&type=style&index=0&id=5c447214&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c447214",
  null
  
)

export default component.exports